import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { checkAuthentication, acceptInvite } from "../../services/InviteService";
import "./Invite.css";

const InvitePage = () => {
  const { uniqid, title } = useParams();
  const [message, setMessage] = useState("Hazırlık yapılıyor...");
  const navigate = useNavigate();

  useEffect(() => {
    let cancelled = false;

    const extractProject = (res) => {
      const p = res?.project || res?.data?.project || {};
      const id = p?.id || res?.projectId || res?.id || 0;
      const name = p?.name || res?.title || title || "Proje";
      const uniq = p?.uniq || res?.projectUniq || res?.uniq || "";
      return { uniq, id, name };
    };

    const run = async () => {
      try {
        setMessage("Kimlik doğrulama yapılıyor...");
        const isAuthenticated = await checkAuthentication();

        if (cancelled) return;

        if (!isAuthenticated) {
          setMessage("Giriş yapmanız gerekmektedir, yönlendiriliyor...");
          setTimeout(() => {
            navigate(`/login?route=/invite/${uniqid}/${title}`, {
              state: { from: `/invite/${uniqid}` },
            });
          }, 1500);
          return;
        }

        setMessage("Projeye katılım sağlanıyor...");
        const result = await acceptInvite(uniqid);

        if (cancelled) return;

        const proj = extractProject(result);
        setMessage("Projeye başarıyla katıldınız, yönlendiriliyor...");

        setTimeout(() => {
          const safeName = encodeURIComponent(proj.name);
          navigate(`/bugs/${proj.uniq || proj.id}/0/${safeName}`);
        }, 1500);
      } catch (e) {
        if (cancelled) return;
        console.error("Invite akışı hata:", e);
        const detail = e?.message ? ` (${e.message})` : "";
        setMessage(`Bir hata oluştu${detail}, yönlendiriliyor...`);
        setTimeout(() => navigate("/dashboard"), 2500);
      }
    };

    run();
    return () => {
      cancelled = true;
    };
  }, [uniqid, title, navigate]);

  return (
    <div className="invite-page-container">
      <div className="invite-logo">
        <img src="/logo_blue.svg" alt="Logo" className="logo" />
      </div>
      <div className="invite-message">
        <p>{message}</p>
      </div>
      <div className="loader"></div>
    </div>
  );
};

export default InvitePage;
